import { render } from "./UserInfoItem.vue?vue&type=template&id=445501ca&scoped=true"
import script from "./UserInfoItem.vue?vue&type=script&lang=js"
export * from "./UserInfoItem.vue?vue&type=script&lang=js"

import "./UserInfoItem.vue?vue&type=style&index=0&id=445501ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445501ca"]])

export default __exports__